export const PortalBrand = () => {
  return (
    <img
      src={'/crew-backstage-lockup.svg'}
      alt={'Crew-Backstage'}
      className={'h-32 w-auto'}
    />
  )
}
